export default __webpack_public_path__ + "static/media/backer-gsv.9db4e89f.png";